import { CFIEstimateDetails } from "./CFIEstimateDetails";

export interface UpdateEstimateParams {
	estimate: CFIEstimateDetails,
	updateType: EstimateUpdateType
}

export enum EstimateUpdateType {
	Info = 1,
	CustomerContact = 2,
	Schedule = 3,
	CustomerInfo = 4,
}
